export enum RegisterStep {
  AccountSelection,
  SubscriptionSelection,
  Finalize,
}
